import {isNull} from "@kubric/utils";
import {Link} from "gatsby";
import {OutboundLink} from "gatsby-plugin-google-analytics";
import {StaticImage} from "gatsby-plugin-image";
import React, {useEffect, useState} from "react";
import ArrowRight from "react-feather/dist/icons/arrow-right";
import ChevronDown from "react-feather/dist/icons/chevron-down";
import ChevronUp from "react-feather/dist/icons/chevron-up";

import {useMediaQuery} from "../../hooks/useMediaQuery";
import "./headerStyles.scss";

const ExternalLink = ({to, ...props}) => <a href={to} {...props} />;

let navigationConfig = ({isMobile}) => [
  {
    type: "dropdown",
    name: "Products",
    linkSize: isMobile ? "medium" : "big",
    links: [
      {
        name: "ModeMagic",
        image: (
          <StaticImage
            className='logoIcon'
            src='https://media.kubric.io/api/assetlib/ac095087-0e5c-4841-becd-d7aba8770dba.png'
            alt='logo modemagic'
          />
        ),
        desc: "Boost sales through better product listings",
        url: "/modemagic",
      },
      {
        name: "Mason",
        image: (
          <StaticImage
            className='logoIcon'
            src='https://media.kubric.io/api/assetlib/e3ccd019-b003-4e8e-9617-371be3c9b996.png'
            alt='logo mason'
          />
        ),
        desc: "The growth platform built for e-commerce",
        url: "/features",
      },
    ],
  },
  {
    type: "dropdown",
    name: "Integrations",
    linkSize: "small",
    links: [
      {
        name: "Figma",
        url: "/integrations?i=0",
        image: (
          <StaticImage
            className='logoIcon'
            src='https://media.kubric.io/api/assetlib/ca909aec-4aac-46da-b3f7-09a82328e737.png'
            alt='Figma'
          />
        ),
      },
      {
        name: "Sketch",
        url: "/integrations?i=1",
        image: (
          <StaticImage
            className='logoIcon'
            src='https://media.kubric.io/api/assetlib/f074d72f-164d-4034-90d1-67228d04bfe7.png'
            alt='Sketch'
          />
        ),
      },
      {
        name: "Photoshop",
        url: "/integrations?i=3",
        image: (
          <StaticImage
            className='logoIcon'
            src='https://media.kubric.io/api/assetlib/0eea367b-d48b-449d-a920-deaabd4da80e.png'
            alt='Photoshop'
          />
        ),
      },
      {
        name: "Mailchimp",
        url: "/integrations?i=0",
        image: (
          <StaticImage
            className='logoIcon'
            src='https://media.kubric.io/api/assetlib/f29d0720-6ae0-44c8-9dfc-3cc9a9ef9003.png'
            alt='Mailchimp'
          />
        ),
      },
      {
        name: "Facebook",
        url: "/integrations?i=0",
        image: (
          <StaticImage
            className='logoIcon'
            src='https://media.kubric.io/api/assetlib/96a944bb-a5c7-4f29-8cad-dd085ff4c0b9.png'
            alt='Facebook'
          />
        ),
      },
      {
        name: "Shopify",
        url: "/integrations?i=0",
        image: (
          <StaticImage
            className='logoIcon'
            src='https://media.kubric.io/api/assetlib/7f9420d5-30a8-45b0-8369-f5f7b2100127.png'
            alt='Shopify'
          />
        ),
      },
      {
        name: "Amazon",
        url: "/integrations?i=0",
        image: (
          <StaticImage
            className='logoIcon'
            src='https://media.kubric.io/api/assetlib/e1ac0b31-bb6c-40e1-a210-e7d36f4aa732.png'
            alt='Amazon'
          />
        ),
      },
      {
        name: "Google",
        url: "/integrations?i=1",
        image: (
          <StaticImage
            className='logoIcon'
            src='https://media.kubric.io/api/assetlib/54b6f397-0e40-4097-b764-109ce0febb20.png'
            alt='Google'
          />
        ),
      },
    ],
  },
  {
    type: "link",
    name: "Partners",
    url: "/partners",
  },
  {
    type: "link",
    name: "Developers",
    url: "https://getmason.dev",
  },
  {
    type: "dropdown",
    name: "Learn & Grow",
    linkSize: "medium",
    links: [
      {
        name: "Makers List",
        desc: "Join an exclusive club of founders, marketers and makers",
        url: "/makerslist",
      },
      {
        name: "Content Hub",
        desc: "Learn how design & content are driving modern commerce",
        url: "/feed",
      },
      {
        name: "Privacy & Security",
        desc: "We take your data privacy & security seriously. Know more",
        url: "/privacypolicy",
      },
      {
        name: "Careers",
        desc: (
          <span>
            We are hiring! <br /> Join a team of makers & builders
          </span>
        ),
        url: "/team",
      },
    ],
  },
];

const MMPricing = {
  type: "link",
  name: "Pricing",
  url: "/modemagic#pricing",
};

const NewLink = ({link = true, children, to, ...props}) => {
  if (link) {
    return (
      <Link to={to} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <OutboundLink href={to} {...props}>
      {children}
    </OutboundLink>
  );
};

const DropLink = ({data, index, trigger, state: propState, menuName}) => {
  const isMobile = useMediaQuery("(max-width: 900px)");
  const [state, setState] = useState(propState);
  const props = {
    [isMobile ? "onClick" : "onMouseEnter"]: trigger.bind(null, index),
  };

  useEffect(() => {
    setState(propState);
  }, [propState]);

  return (
    <div
      className={`action-link ${menuName} relative inline-flex flex-row items-center md:mx-4 ${
        state === index
          ? "opacity-100 open-drop"
          : "opacity-70 hover:opacity-100"
      }`}
      {...(isMobile ? props : state !== index ? props : {})}
    >
      <div
        className='link-content flex items-center justify-between'
        key={state}
      >
        <span className='link-name'>{data.name}</span>
        {isMobile ? (
          <>
            {state === index ? (
              <ChevronUp className='chev up' />
            ) : (
              <ChevronDown className='chev down' />
            )}
          </>
        ) : (
          state === index && <div className='buffer' />
        )}
      </div>
      {state === index && (
        <div
          className={`drop-card p-8 flex flex-row flex-wrap box-border ${data.linkSize}`}
        >
          {data.links.map((tab) => {
            return (
              <NewLink
                link={tab.url.includes("http")}
                to={tab.url}
                className={`tab-link-wrap ${data.linkSize}`}
                key={tab.name}
              >
                <div className='tabs-wrap flex flex-row items-center'>
                  {tab.image && (
                    <div
                      className={`tab-display mr-2 md:mr-5 bg-gray-200 rounded-lg overflow-hidden ${
                        data.linkSize === "big"
                          ? "w-20 md:w-18 h-20 md:h-18"
                          : "w-8 h-8"
                      }`}
                    >
                      {tab.image}
                    </div>
                  )}
                  <div
                    className={`tab-content ${
                      data.linkSize === "small" ? "w-auto md:w-24" : ""
                    } ${data.linkSize === "medium" ? "w-full" : ""}`}
                  >
                    <span className='tab-link-name'>{tab.name}</span>
                    <span className='tab-link-desc opacity-80 light'>
                      {tab.desc}
                    </span>
                  </div>
                </div>
              </NewLink>
            );
          })}
        </div>
      )}
    </div>
  );
};

const Header = ({type = "mason"}) => {
  const isMobile = useMediaQuery("(max-width: 900px)");
  const [navigation, setNavOptions] = useState(navigationConfig({isMobile}));

  useEffect(() => {
    setNavOptions(navigationConfig({isMobile}));
  }, [isMobile]);

  useEffect(() => {
    if (type === "modemagic") {
      setNavOptions([
        ...navigation.slice(0, navigation.length - 1),
        MMPricing,
        ...navigation.slice(navigation.length - 1),
      ]);
    }
  }, []);
  const [isMenuOpen, setMenuState] = useState(false);
  const [dropped, setDrop] = useState(null);
  const triggerDropdown = (i, e) => {
    e.stopPropagation();
    if (e.currentTarget.classList.contains("action-link")) {
      if (dropped === i) {
        setDrop(null);
      } else {
        setDrop(i);
      }
    }
  };
  useEffect(() => {
    const handler = (e) => {
      const currentActionLink =
        document.querySelectorAll(".action-link")[dropped];
      // dont hide it on mobile
      if (!currentActionLink.contains(e.target) && !isMobile) {
        setDrop(null);
      }
    };
    if (!isNull(dropped)) {
      document.body.addEventListener("mouseover", handler);
      return () => document.body.removeEventListener("mouseover", handler);
    }
  }, [dropped]);

  return (
    <div
      className={`header-wrap full-bleed layouted ${
        isMenuOpen ? "h-full" : "h-4/12"
      }`}
    >
      <div className='header-col'>
        <div className='head-wrap flex flex-row items-center justify-between px-4 md:px-2'>
          <Link to='/'>
            <div className='branding flex flex-row items-center justify-center p-2 my-4 rounded-md'>
              {type === "modemagic" ? (
                <div className='mmlogo inline-block'>
                  <StaticImage
                    src='https://media.kubric.io/api/assetlib/463d82bd-d05b-4588-b40d-d4cd07c701ed.png'
                    alt='logo modemagic'
                  />
                </div>
              ) : (
                <div className='masonlogo-wrap flex flex-row items-center'>
                  <StaticImage
                    src='https://media.kubric.io/api/assetlib/638cc2a0-a413-4a84-9e69-7a110d4d5f67.png'
                    alt='logo mason'
                  />
                  &ensp; <span>mason</span>
                </div>
              )}
            </div>
          </Link>
          <div
            className={`ham-menu flex flex-col items-center justify-center md:hidden sm:inline-block ${
              isMenuOpen ? "ham-active" : ""
            }`}
            onClick={() => setMenuState(!isMenuOpen)}
          >
            {Array(3)
              .fill(null)
              .map((_, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className='ham-line' key={`ham-line${i}`} />
              ))}
          </div>

          <div className='actions'>
            {navigation.map((route, i) => {
              if (route.type === "dropdown") {
                return (
                  <DropLink
                    menuName={route.name.toLowerCase()}
                    key={route.name}
                    data={route}
                    index={i}
                    trigger={triggerDropdown}
                    state={dropped}
                  />
                );
              }
              const isExternal = route.url.startsWith("http");
              const LinkElement = isExternal ? ExternalLink : Link;
              return (
                <span
                  key={route.name}
                  className='action-link mx-4 opacity-70 hover:opacity-100'
                >
                  <div className='link-content'>
                    <LinkElement className='link-content' to={route.url}>
                      <span className='link-name'>{route.name}</span>
                    </LinkElement>
                  </div>
                </span>
              );
            })}
            {type === "mason" && (
              <OutboundLink
                href='https://app.getmason.io/login'
                className='sign py-2 px-4 ml-6 rounded-full'
                target='_blank'
                rel='noopener noreferrer'
              >
                Sign up
              </OutboundLink>
            )}
          </div>
        </div>
        {isMenuOpen && (
          <div className='ham-actions md:hidden flex flex-col'>
            {navigation.map((route, i) => {
              if (route.type === "dropdown") {
                return (
                  <DropLink
                    menuName={route.name.toLowerCase()}
                    key={route.name}
                    data={route}
                    index={i}
                    trigger={triggerDropdown}
                    state={dropped}
                  />
                );
              }
              return (
                <span className='action-link opacity-70 hover:opacity-100'>
                  <div className='link-content'>
                    <Link activeClassName='link-active' to={route.url}>
                      <span className='link-name'>{route.name}</span>
                    </Link>
                  </div>
                </span>
              );
            })}
            {isMobile ? (
              <button
                className='headerCta'
                type='button'
                onClick={() => {
                  let newWindow = window.open("https://app.getmason.io/login");
                  newWindow.opener = null;
                }}
              >
                Get Started for Free
              </button>
            ) : (
              <OutboundLink
                href={
                  type === "mason"
                    ? "https://app.getmason.io/login"
                    : "https://creativesparks.typeform.com/to/WfiUem5k"
                }
                className='main-cta flex items-center'
              >
                {type === "mason" ? "Sign up" : "Book a demo"}&ensp;
                <ArrowRight />
              </OutboundLink>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
